module.exports = __webpack_public_path__ + "img/s2P32.f2311345.png";